import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export function useChangePassword() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (values) => {
        const { username, password, token } = values;

        setIsLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await fetch(
                `${import.meta.env.VITE_APP_API_URL}/resetpassword/`,
                {
                    headers: {
                        accept: 'application/json, text/plain, */*',
                        'content-type': 'application/json;charset=UTF-8',
                        'x-requestscope': '20',
                    },
                    method: 'POST',
                    mode: 'cors',
                    body: JSON.stringify({
                        username,
                        password,
                        token,
                    }),
                },
            );

            if (response.status === 200) {
                setError(null);
                setSuccess(true);
                toast.success(
                    'Password changed successfully! Redirecting to login...',
                );
                // Navigate with success state
                setTimeout(() => {
                    navigate('/?changePassword=success');
                }, 2000);
            } else {
                const data = await response.json();
                const errorMessage =
                    data.message ||
                    'Failed to change password. Please try again.';
                setSuccess(false);
                setError(errorMessage);
                toast.error(errorMessage);
            }
        } catch (err) {
            const errorMessage =
                'Network error. Please check your connection and try again.';
            setSuccess(false);
            setError(errorMessage);
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const resetMessages = () => {
        setError(null);
        setSuccess(false);
    };

    return {
        handleSubmit,
        isLoading,
        error,
        success,
        resetMessages,
    };
}
